package com.trevorwiebe.timesheet.core.domain.dto

import com.trevorwiebe.timesheet.core.domain.model.Customer
import kotlinx.serialization.Serializable

@Serializable
data class CustomerDto(
    val contactName: String = "",
    val companyName: String = "",
    val address: String = "",
    val phone: String = "",
    // Older app versions read and write only [email]; it mirrors the first of [emails].
    val email: String = "",
    val emails: List<String> = emptyList(),
    val paymentTerms: String = "",
    val notes: String = "",
    val deleted: Boolean = false
)

fun CustomerDto.toCustomer(id: String) = Customer(
    id = id,
    contactName = contactName,
    companyName = companyName,
    address = address,
    phone = phone,
    emails = emails.ifEmpty { listOf(email).filter { it.isNotBlank() } },
    paymentTerms = paymentTerms,
    notes = notes,
    deleted = deleted
)

fun Customer.toCustomerDto() = CustomerDto(
    contactName = contactName,
    companyName = companyName,
    address = address,
    phone = phone,
    email = emails.firstOrNull().orEmpty(),
    emails = emails,
    paymentTerms = paymentTerms,
    notes = notes,
    deleted = deleted
)
